module.exports = __webpack_public_path__ + "img/Loan.0b401486.svg";